Controller = App.loadClass 'core::Angular/Controller'
string_utils = App.load 'core::utils/string'

class exports.DefineController extends Controller

    constructor: (@scope, @transitions, @state, @filterService, @service, @window, @changes) ->
        super(@scope, @transitions)

        # Clear any existing changes
        @scope.cancel = @cancel
        @scope.save = @save
        @boundariesToMarkers = []
        @markersToBoundaries = []

        # Color Options
        @availableStatus =
            'Selected': '#3286AB'
            'Not Key': '#a9a9a9'
            'Not Started': '#00FF00'
            'Incomplete': '#5ac272'
            'Complete': '#5ac272'

        # Watch the current filters to see if the change
        # when the do run report to fetch fields
        @scope.$watch () =>
            @filterService.current_filters
        , (current_filters) =>
            @filters = current_filters

            # Fetch Fields
            @loadData()

        # Handle unsaved changes warning
        @transitionStart = @transitions.onStart {}, ($transition) =>
            # if we're going to a child state, don't worry about unsaved changes
            if string_utils.startsWith $transition.to().name, @state.current.name
                return

            # if there are unsaved changes, warn the user
            if @changes.changesMade()
                if not @window.confirm('You have unsaved changes.\n\nAre you sure you want to leave this page?')
                    return false
                else
                    # Deregister the listener so the warning can't be triggered
                    # multiple times due to multiple consecutive state changes.
                    # Edit: Do we still have to do this? I don't know.
                    # deregisterStateChangeStart()
                    App.layer_store.empty()
            else
                App.layer_store.empty()

        @window.onbeforeunload = () =>
            # if there are unsaved changes, warn the user
            if @changes.changesMade()
                return 'You have unsaved changes.'

            return null # doesn't show a warning

        # deregister the event listeners when the scope is destroyed so we
        # don't create memory leaks
        @scope.$on '$destroy', () =>
            @window.onbeforeunload = null
            @transitionStart()


    # Initialize fields map layer
    initBoundaryLayer: () =>
        @oldMaxZoom = App.map.options.maxZoom
        App.map.options.maxZoom = 17
        @maxZoom = 12

        @boundaryLayer = new L.FeatureGroup()

        App.layer_store.store 'fields_layer', @boundaryLayer
        App.map.on 'zoomend', @updateBoundaries


    # Initialize marker map layer
    initMarkerLayer: () =>
        @markerLayer = new L.MfMarkerClusterGroup
            zoomToBoundsOnClick: true

        App.layer_store.store 'marker_cluster', @markerLayer


    ###
    Initialize marker icons. These are the pushpins that represent
    a field on the map, and they are colorcoded by key field status.
    ###
    generateMarkerIcons: () =>
        @icons = {}
        for status, color of @availableStatus
            @icons[status] =  new L.mapbox.marker.icon
                'marker-size': 'large'
                'marker-color': color
                'marker-symbol': 'farm'


    updateBoundaries: () =>
        if App.map.getZoom() > @maxZoom
            #show all boundaries
            App.map.addLayer @boundaryLayer
        else
            App.map.removeLayer @boundaryLayer

    ###
    Add fields to map
    ###
    populateMapWithFieldBoundaries: (results) =>
        fields = results.fields
        bounds = results.bounds
        @changes.clear()

        # Add field boundaries to map
        for field in fields
            if field.mid_lat? and field.mid_lng?

                # If key field push store id
                if field.status isnt 'Not Key'
                    @changes.keyFields.push field.id
                    @changes.originalKeyFields.push field.id

                # Create field boundary
                boundary = L.geoJson $.parseJSON(field.json),
                    style: () =>
                        return {
                            weight: 2,
                            opacity: 1,
                            fillOpacity: .5
                            color: @availableStatus[field.status],
                            fillColor: @availableStatus[field.status],
                        }

                # Event listeners for Field
                @createBoundaryEventListener boundary

                # Create Marker
                boundary.field = field
                marker = @createMarkerFromBoundary boundary, field.status
                boundary.marker = marker

                # Add Boundary/Marker to map
                @boundaryLayer.addLayer boundary
                @markerLayer.addLayer marker

        # Zoom map to fit fields with padding
        if fields.length > 0
            App.map.fitBounds([
                [bounds.south, bounds.west],
                [bounds.north, bounds.east]
            ], padding: [30, 30])

    ###
    Handles highlighting of boundary when clicking on marker
    ###
    createMarkerEventListener: (marker) =>
        marker.on 'click', (e) =>
            @markerLayer.eachLayer (marker) =>
                if marker._leaflet_id is e.target._leaflet_id
                    @updateBoundary marker.boundary._leaflet_id


    ###
    Handles highlighting of boundary when clicking on fields
    ###
    createBoundaryEventListener: (boundary) =>
        boundary.on 'click', (e) =>
            layer_id = e.target._leaflet_id
            @updateBoundary layer_id

    ###
    Create Marker/Listener from Field and status
    ###
    createMarkerFromBoundary: (boundary, status) =>
        statusIcon = @icons[status]
        marker = L.marker [boundary.field.mid_lat, boundary.field.mid_lng], { icon: statusIcon }
        marker.boundary = boundary

        # Create pop up for each field
        if status is 'Incomplete' or status is 'Complete'
            marker.bindPopup 'This Key Field has been sampled.', closeButton: false
        else if status is 'Not Key'
            marker.bindPopup 'This is not a Key Field.', closeButton: false
        else if status is 'Not Started'
            marker.bindPopup 'This is a Key Field.', closeButton: false
        else if status is 'Selected'
            marker.bindPopup 'This will become a Key Field.', closeButton: false

        # Add Popup to marker and boundary
        marker.on 'mouseover', (e) ->
            @openPopup()

        marker.on 'mouseout', (e) ->
            @closePopup()

        boundary.on 'mouseover', (e) ->
            marker.openPopup()

        boundary.on 'mouseout', (e) ->
            marker.closePopup()

        # Event listeners for Marker
        @createMarkerEventListener marker
        return marker

    ###
    Update Boundary based on the boundary id
    ###
    updateBoundary: (layer_id) =>
        # Find layer and update
        @boundaryLayer.eachLayer (boundary) =>

            # only allow update if the field is
            is_same = boundary._leaflet_id is layer_id
            not_key = boundary.field.status is 'Not Key'
            not_started = boundary.field.status is 'Not Started'

            if is_same and (not_started or not_key)
                # If its already select it deselect
                index = @changes.keyFields.indexOf boundary.field.id
                if index > -1
                    new_status = 'Not Key'
                    not_key = @availableStatus[new_status]
                    boundary.setStyle { color: not_key, fillColor: not_key }

                    @updateMarker layer_id, new_status
                    @changes.keyFields.splice index, 1

                else
                    # Else select it (if key field revert to key field green)
                    if not_started
                        new_status = 'Not Started'
                    else
                        new_status = 'Selected'

                    selected = @availableStatus[new_status]
                    boundary.setStyle { color: selected, fillColor: selected }

                    @updateMarker layer_id, new_status
                    @changes.keyFields.push boundary.field.id


    ###
    Update the marker for the given boundary from old status to new status
    NOTE: markers are image files so they must be replaced entirely
    ###
    updateMarker: (boundary_id, new_status) =>
        @markerLayer.eachLayer (marker) =>
            # If marker is old status replace with new status
            if marker.boundary._leaflet_id is boundary_id
                new_marker = @createMarkerFromBoundary marker.boundary, new_status
                @markerLayer.removeLayer marker
                @markerLayer.addLayer new_marker


    ###
    Reset boundary/markers and field ids
    ###
    cancel: () =>
        to_add = @changes.toAdd()
        to_delete = @changes.toDelete()

        # Reset only boundaries that have changed
        @boundaryLayer.eachLayer (boundary) =>
            if to_add.indexOf(boundary.field.id) > -1
                status = @availableStatus[boundary.field.status]
                boundary.setStyle { color: status, fillColor: status }
                @updateMarker boundary._leaflet_id, boundary.field.status

            if to_delete.indexOf(boundary.field.id) > -1
                status = @availableStatus[boundary.field.status]
                boundary.setStyle { color: status, fillColor: status }
                @updateMarker boundary._leaflet_id, boundary.field.status

        # reset field ids
        @changes.reset()


    ###
    Save Key Fields for given year and reload
    ###
    save: () =>
        if not @changes.changesMade()
            @scope.$emit 'KeyFieldDefine:displayMessage',
                type: 'info'
                msg: 'No changes to save'

            return

        @scope.$emit 'KeyFieldDefine:displayMessage',
            type: 'info'
            msg: 'Saving...'

        # send save request
        @service.save @filters.years[0].value, @changes.toAdd(), @changes.toDelete()
            .then (response) =>
                jsr = response.data
                @scope.$emit 'KeyFieldDefine:displayMessage', jsr.status

                # If successful reload
                if jsr.status.type is 'success'
                    @changes.update()
                    @loadData()


    loadData: () =>
        # Clear all layers and reinitiate
        App.layer_store.empty()
        @generateMarkerIcons()
        @initBoundaryLayer()
        @initMarkerLayer()

        @service.fetchFields @filters
            .then (response) =>
                jsr = response.data
                @populateMapWithFieldBoundaries(jsr.data.results)
